import { EmailSyncOutlineIcon } from './EmailSyncOutlineIcon';

/**
 * author: Simran
 * id 0FAB1B0E-FEAB-4F12-A7FC-58D48CB9682F
 * name email-sync-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-sync-outline.svg
 * tags
 */
export const EmailResendOutlineIcon = EmailSyncOutlineIcon;
export default EmailResendOutlineIcon